import { useEffect, useState } from 'react';
import { getInstructionalLevels } from '../../services/calculator/getInstructionalLevelsService.js';

export const useInstructionalLevels = () => {
    const [instructionalLevels, setInstructionalLevels] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const loadInstructionalLevels = async () => {
            try {
                const data = await getInstructionalLevels();
                setInstructionalLevels(data);
            } catch {
                setError('Error cargando los niveles instruccionales.');
            } finally {
                setLoading(false);
            }
        };

        loadInstructionalLevels();
    }, []);

    return {
        instructionalLevels,
        loading,
        error
    };
}